import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const VerifyEmailNotice = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                className="max-w-md w-full bg-white dark:bg-gray-800 p-8 rounded-xl border border-gray-200 dark:border-gray-700 text-center"
            >
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                    Verify Your Email
                </h2>
                <p className="text-gray-700 dark:text-gray-300 mb-6">
                    Thank you for signing up! A verification email has been sent to your email address.
                    Please click the link in the email to verify your account before logging in.
                </p>
                <Link
                    to="/signin"
                    className="inline-block px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-lg transition-colors"
                >
                    Go to Sign In
                </Link>
            </motion.div>
        </div>
    );
};

export default VerifyEmailNotice;
